import { authSlice } from "./authSlice";

import * as authServices from "./authServices";
const actions = authSlice.actions;

export const login = (formData, onSuccess, onError) => {
  return async (dispatch) => {
    dispatch(actions.startCall("action"));
    try {
      const res = await authServices.login(formData);
      dispatch(actions.login(res?.data?.data));
      onSuccess();
    } catch (error) {
      dispatch(actions.stopCall("action"));
      onError(error);
    }
  };
};

export const logout = (onSuccess) => async (dispatch) => {
  dispatch(actions.startCall("action"));
  try {
    dispatch(actions.logout());
    onSuccess();
  } catch (error) {
    dispatch(actions.stopCall("action"));
  }
};

export const loadUserByToken = () => async (dispatch) => {
  dispatch(actions.startCall("action"));
  try {
    const res = await authServices.loadUserByToken();
    dispatch(actions.loadUserByToken(res?.data?.data));
  } catch (error) {
    dispatch(actions.stopCall("action"));
  }
};

export const verifyEmail = (payload, onSuccess, onError) => async (dispatch) => {
  dispatch(actions.startCall("action"));
  try {
    const res = await authServices.verifyEmail(payload);
    dispatch(actions.stopCall("action"));
    onSuccess(res);
  } catch (error) {
    dispatch(actions.stopCall("action"));
    onError(error);
  }
};

export const resetPassword = (password, token, onSuccess, onError) => async (dispatch) => {
  dispatch(actions.startCall("action"));
  try {
    const res = await authServices.resetPassword(password, token);
    dispatch(actions.stopCall("action"));
    onSuccess(res);
  } catch (error) {
    dispatch(actions.stopCall("action"));
    onError(error);
  }
};
